import _slicedToArray from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { __rest } from "tslib";
import * as React from 'react';
import { Button } from '../Button';
import TimesIcon from '@patternfly/react-icons/dist/esm/icons/times-icon';
import { FindRefWrapper } from '../../helpers/Popper/FindRefWrapper';
export var PopoverCloseButton = function PopoverCloseButton(_a) {
  var _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return undefined;
  } : _a$onClose,
      props = __rest(_a, ["onClose"]);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      closeButtonElement = _React$useState2[0],
      setCloseButtonElement = _React$useState2[1];

  React.useEffect(function () {
    closeButtonElement && closeButtonElement.addEventListener('click', onClose, false);
    return function () {
      closeButtonElement && closeButtonElement.removeEventListener('click', onClose, false);
    };
  }, [closeButtonElement]);
  return React.createElement(FindRefWrapper, {
    onFoundRef: function onFoundRef(foundRef) {
      return setCloseButtonElement(foundRef);
    }
  }, React.createElement(Button, Object.assign({
    variant: "plain",
    "aria-label": true
  }, props, {
    style: {
      pointerEvents: 'auto'
    }
  }), React.createElement(TimesIcon, null)));
};
PopoverCloseButton.displayName = 'PopoverCloseButton';